import React, { useState } from 'react';

import { AlineChip } from 'src/components';
import type { WorkflowWithLabels } from 'src/workflow/labels';
import { WorkflowLabelEditor } from 'src/workflow/labels';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  ghostChip: {
    border: `1px dashed ${theme.appColors.rule}`,
  },
  labelsRow: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    justifyContent: 'flex-start',
    width: 'fit-content',
  },
}));

interface WorkflowCardLabelsProps {
  workflow: WorkflowWithLabels;
}

export function WorkflowCardLabels({ workflow }: WorkflowCardLabelsProps): JSX.Element {
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const sortedLabels = [...workflow.labels].sort((a, b) => a.labelText.localeCompare(b.labelText));

  return (
    <div ref={setAnchorEl} className={classes.labelsRow}>
      {sortedLabels.map((label, index) => (
        <AlineChip
          key={index}
          chipText={label.labelText}
          onClick={e => {
            e.stopPropagation();
            setOpen(true);
          }}
        />
      ))}
      <AlineChip
        chipText="Add label +"
        className={classes.ghostChip}
        onClick={e => {
          e.stopPropagation();
          setOpen(true);
        }}
      />
      <WorkflowLabelEditor
        popoverProps={{
          anchorEl,
          anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
          onClose: () => setOpen(false),
          open,
          style: { transform: `translateY(8px)` },
          transformOrigin: { horizontal: 'left', vertical: 'top' },
        }}
        workflow={workflow}
      />
    </div>
  );
}
